import edit from './edit'

export default { edit, options: { label: 'Pages Promises' } }
